import { Code2, Globe2, HeartHandshake } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import { SITE } from '@/lib/site';

const HIGHLIGHTS = [
  {
    icon: Code2,
    title: 'Protocol-first',
    description: 'I work close to the metal — NIPs, BIPs, and the libraries that implement them.',
  },
  {
    icon: Globe2,
    title: 'Built from Nairobi',
    description: 'Designing for real-world constraints: intermittent connectivity, mobile-first, low fees.',
  },
  {
    icon: HeartHandshake,
    title: 'Open by default',
    description: 'Everything I ship is free and open source. Code is a commons.',
  },
];

export function About() {
  return (
    <section id="about" className="scroll-mt-20 border-t border-border/60">
      <div className="container py-20 md:py-28">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.4fr] lg:gap-16">
          <div className="space-y-4">
            <p className="font-mono text-sm text-bitcoin">// about me</p>
            <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
              Sovereignty is a feature, not a slogan
            </h2>
            <div className="flex flex-wrap gap-2 pt-2">
              {SITE.stack.map((tech) => (
                <Badge key={tech} variant="secondary" className="rounded-full px-3 py-1 font-mono text-xs">
                  {tech}
                </Badge>
              ))}
            </div>
          </div>

          <div className="space-y-8">
            <div className="space-y-4 text-base leading-relaxed text-muted-foreground md:text-lg">
              {SITE.about.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </div>

            <div className="grid gap-4 sm:grid-cols-3">
              {HIGHLIGHTS.map((item) => (
                <Card key={item.title} className="bg-card/60">
                  <CardContent className="space-y-3 p-5">
                    <item.icon className="size-5 text-bitcoin" />
                    <h3 className="font-display font-semibold">{item.title}</h3>
                    <p className="text-sm leading-relaxed text-muted-foreground">{item.description}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
